module.exports = __webpack_public_path__ + "static/img/AppStore_QR.87a8279c.png";